// extracted by mini-css-extract-plugin
export default {"form_group":"style_form_group__jicPz"};